module.exports = __webpack_public_path__ + "img/employee.6170b16d.png";